import { useState, useEffect } from "react";
import axios from "axios";
import AllRoutes from "./routes";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

const App = () => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Global Axios interceptor: auto-logout when Token is Expired
  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => {
        const msg = response?.data?.message || response?.data?.status || "";
        if (typeof msg === "string" && msg.toLowerCase().includes("token is expired")) {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("is_activated");
          sessionStorage.removeItem("seller_approved");
          sessionStorage.removeItem("isSkipped");
          toast.error("Session expired. Please login again.", { toastId: "token_expired" });
          window.location.href = "/";
        }
        return response;
      },
      (error) => {
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.status ||
          error?.message ||
          "";
        if (typeof msg === "string" && msg.toLowerCase().includes("token is expired")) {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("is_activated");
          sessionStorage.removeItem("seller_approved");
          sessionStorage.removeItem("isSkipped");
          toast.error("Session expired. Please login again.", { toastId: "token_expired" });
          window.location.href = "/";
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, []);

  return (
    <>
      {!isOnline && (
        <div
          style={{
            position: "fixed",
            top: "12px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "linear-gradient(90deg, #dc2626, #b91c1c)",
            color: "#ffffff",
            padding: "8px 20px",
            borderRadius: "24px",
            boxShadow: "0 4px 14px rgba(220, 38, 38, 0.4)",
            zIndex: 999999,
            fontWeight: 600,
            fontSize: "13px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            letterSpacing: "0.2px",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#ffffff",
              display: "inline-block",
            }}
          />
          You are offline. Please check your internet connection.
        </div>
      )}

      <AllRoutes />
      <ToastContainer />
    </>
  );
};

export default App;
